export enum MAIL_NOTIFICATION_STATUS_EMAIL_TYPE {
  InvoiceWithLink = 1,
  InvoiceWithAttachment = 2,
  InvoiceWithAttachmentAndXml = 3,
  PaymentReminder = 4,
  PaymentDemand = 5,
  PreLitigationPaymentDemand = 6,
  RemindToSendDocument = 7,
  WrongSubjectBookingFile = 8,
  VindicationSentEmailsReport = 9,
  AutomaticReport = 10,
  UserPasswordReset = 11,
  InvoiceWithXml = 12,
  InvoiceWithKsefLink = 17,
}
